module.exports = __webpack_public_path__ + "static/img/develop3.32839fd7.png";